module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-name-box"
  }, [_c('b', {
    staticClass: "contract-number"
  }, [_vm._v(_vm._s(_vm.contractId) + " -")]), _vm._v(" "), _c('div', {
    staticClass: "editable"
  }, [(_vm.editing) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "form-control plan-label-input",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-name-box-edit",
    on: {
      "click": _vm.edit
    }
  }, [(!_vm.editing) ? _c('div', {
    staticClass: "edit-header",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Editar o nome do plano"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.newValue) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.currentBalance) ? _c('p', {
    staticClass: "balance-box"
  }, [_c('span', [_vm._v("Saldo: ")]), _vm._v(" "), _c('span', {
    staticClass: "bold",
    class: _vm.currentBalance >= 0 ? 'green' : 'red'
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.currentBalance)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Cancelar edição"
    },
    on: {
      "click": _vm.cancel
    }
  }, [(_vm.editing && !_vm.loading) ? _c('i', {
    staticClass: "icon-cancel-edit"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Salvar edição"
    },
    on: {
      "click": _vm.confirm
    }
  }, [(_vm.editing && !_vm.loading) ? _c('i', {
    staticClass: "icon-check-edit"
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-3cb6522b!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/contract-name.vue
// module id = 2106
// module chunks = 1